import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PurchaseorderService } from '../../../services/purchaseorder.service';
import { gridPageRequest, StoreConsumptionGridResponse } from '../../../model/common/common.model';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StoreConsumptionLookupComponent } from '../../Lookup/store-consumption-lookup/store-consumption-lookup.component';
import { ReportCenterService } from '../../../services/report-center.service';
import { ReportLookupComponent } from '../../Reports/report-lookup/report-lookup.component';
import { InventoryService } from '../../../services/inventory.service';

@Component({
  selector: 'app-store-consumptions',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './list-store-consumptions.component.html',
  styleUrl: './list-store-consumptions.component.scss'
})
export class ListStoreConsumptionsComponent implements OnInit {

  @ViewChild('dt1') dt1: Table | undefined;

  storeConsumptionData: any[] = [];
  selectedStoreConsumptions: any[] = [];
  loader: boolean = false;
  loading: boolean = false;
  searchKey: string = '';
  layout: 'list' | 'grid' = 'list';
  SaveDataLineItem: any;
  unitLabel: string = '';


  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 10,
    id: 0
  };

  refStoreConsumption: DynamicDialogRef | undefined;

  constructor( private purchaseorderService: PurchaseorderService, private messageService: MessageService, private confirmationService: ConfirmationService, private dialogService: DialogService, private router: Router ,private reportService : ReportCenterService, public ref: DynamicDialogRef, public inventoryService: InventoryService) {}

  ngOnInit(): void {
    document.title = 'Store Consumptions List'; 
    this.loadStoreConsumptions();
    this.searchEffect();
      this.inventoryService.getUnitByAppKey('unitNameLabel').subscribe((res: any) => { 
      this.unitLabel = res?.data || 'Unit'; 
    });
  }


  loadStoreConsumptions() {
    this.loading = true;
    const requestData = {
      ...this.pageRequest,
      searchText: this.searchKey
    };

    this.purchaseorderService.getAllStoreConsumption(requestData).subscribe({
      next: (response: StoreConsumptionGridResponse) => {
        this.storeConsumptionData = response.storeConsumption || [];
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading store consumptions:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load store consumptions'
        });
        this.loading = false;
      }
    });
  }

  searchStoreConsumptions() {
    this.pageRequest.pageIndex = 0;
    this.loadStoreConsumptions();
  }

  onPageChange(event: any) {
    this.pageRequest.pageIndex = event.page;
    this.pageRequest.pageSize = event.rows;
    this.loadStoreConsumptions();
  }

  addStoreConsumption() {
    this.router.navigate(['/home/createStoreConsumption']);
  }

 editStoreConsumption(storeConsumption?: any) {
  const selectedItem = storeConsumption || (this.selectedStoreConsumptions.length === 1 ? this.selectedStoreConsumptions[0] : null);

  if (!selectedItem) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Warning',
      detail: 'Please select a store consumption to edit'
    });
    return;
  }

  this.router.navigate(['/home/createStoreConsumption'], { queryParams: { id: selectedItem.storeConsumptionId }, skipLocationChange: true });
}

  deleteStoreConsumption() {
    if (!this.selectedStoreConsumptions || this.selectedStoreConsumptions.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please select store consumptions to delete'
      });
      return;
    }

    this.confirmationService.confirm({
      header: 'Confirm Delete',
      message: `Are you sure you want to delete ${this.selectedStoreConsumptions.length} selected store consumption(s)?`,
      accept: () => {
        this.loader = true;
        const deleteIds = this.selectedStoreConsumptions.map(item => item.storeConsumptionId);

        this.purchaseorderService.deleteStoreConsumption(deleteIds).subscribe({
          next: (response) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Store consumption(s) deleted successfully'
            });
            this.selectedStoreConsumptions = [];
            this.loadStoreConsumptions();
            this.loader = false;
          },
          error: (error) => {
            console.error('Error deleting store consumption:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to delete store consumption(s)'
            });
            this.loader = false;
          }
        });
      }
    });

  }

  refreshData() {
    this.loadStoreConsumptions();
    this.searchKey = '';
  }

  searchStoreConsumption() {
    if (this.searchKey && this.searchKey.trim().length >= 2) {
      this.purchaseorderService.SearchStoreConsumption(this.searchKey.trim()).subscribe({
        next: (res: any) => {
          this.storeConsumptionData = res || [];
        },
        error: (err) => {
          console.error('Search error:', err);
        }
      });
    } else {
      this.loadStoreConsumptions();
    }
  }

showReport(value: any): void {
  const formCode = 'Store Consumption';

  this.reportService.getReportName(formCode).subscribe({
    next: (report: any) => {
      const scCode = value.scCode;
      const sanitizedCode = scCode.replace(/[^a-zA-Z0-9]/g, "_");
      document.title = sanitizedCode;
      this.ref = this.dialogService.open(ReportLookupComponent, {
        header: 'Store Consumption',
        width: '100%',
        data: {
          OrderNo: scCode,
          ReportName: sanitizedCode,
          ReportPath: report.path
        }
      });

      this.ref.onClose.subscribe(() => {
        this.searchKey = '';
        document.title = 'Store Consumptions List';
      });
    },
    error: (err) => {
      console.error('Report not found for form code:', formCode, err);
    }
  });
}


  placeholder: string = 'Search By ';
  private messages: string[] = ['Employee Name', 'Project'];
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }

}
